module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"tool-title":"Données","no-data-title":"Aucune donnée","oid":"Identifiant DB","publicId":"Identifiant REGIS","name":"Nom"},"de":{}}')
  delete Component.options._Ctor
}
